<template>
  <modal
    id="second-step-verification"
    class="second-step-verification"
    @shown="onModalShown"
  >
    <div class="boxVerification">
      <div class="" id="bp-left">
        <div class="partition" id="partition-verification">
          <div class="partition-title">2-Step verification</div>

          <div class="col-md-12" style="text-align: center">
            <img
              :src="companyLogo || companyLogoPlaceholder"
              class="site-rounded-logo rounded"
            />
          </div>
          <div class="partition-form">
            <form autocomplete="false">
              <div class="col-md-11 form-container">
                <div class="col-md-12 text-center" style="text-align: left">
                  <h3>Enter the token we just sent you via email and SMS</h3>
                </div>
                <div class="col-md-12 mb-4 d-flex justify-content-center">
                  <otp-input
                    ref="otpInput"
                    :key="otpKey"
                    :digits="6"
                    type="text"
                    placeholder=""
                    :isDisabled="loading"
                    :isLoading="loading"
                    :isValid="isOtpValid"
                    @on-complete="verifyToken"
                    @on-changed="onOtpChanged"
                  />
                </div>
                <a href="#" @click.prevent="!loading && closeModal()"
                  >Start Over</a
                >
                <div class="mt-4">
                  Need help? Contact
                  <a href="mailto:info@communitycareconnection.com"
                    >Our Support</a
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OtpInput from "@/components/OtpInput.vue";
import Swal from "sweetalert2";
import Auth from "@/auth.js";

export default {
  name: "TwoStepVerificationModal",
  props: ["user"],
  components: {
    OtpInput,
  },
  data() {
    return {
      loading: false,
      companyLogoPlaceholder: "/favicon/c3-logo.png",
      isOtpValid: true,
      otpKey: 0,
    };
  },
  computed: {
    ...mapState(["auth"]),
    companyLogo() {
      const root = (this.$store || {}).state || {};
      const settings = root.settings || {};
      return settings.companyLogo || null;
    },
  },
  methods: {
    ...mapActions({
      doVerification: "auth/secondStepVerification",
      doLogout: "auth/logout",
      getVendors: "vendors/getSignedInVendors",
    }),
    verifyToken: function (token) {
      let vm = this;
      this.loading = true;
      this.doVerification({
        token,
      })
        .then(function (res) {
          vm.loading = false;
          if (res) {
            Auth.verify.set(true);
            vm.$store.dispatch("hideModal", "second-step-verification");
            if (vm.auth.iframeSrc == "crm") {
              window.location.href = `/orders?src=${vm.auth.iframeSrc}&keeplogin=true`;
            } else {
              if ((vm.user || {}).isVendor) {
                vm.getVendors({
                  accessToken: vm.auth.token,
                }).then(function (vendors) {
                  if (vendors && vendors.length) {
                    window.location.href = `/vendors/${vendors[0].id}?login=${vendors.length}`;
                  }
                });
              } else {
                window.location.href = "/";
              }
            }
          }
        })
        .catch(function (err) {
          vm.loading = false;
          if (!err || !err.accessDenied) {
            Swal.fire({
              type: "error",
              title: "Invalid Verification Token",
            });
          }
        });
    },
    onOtpChanged: function () {
      if (!this.isOtpValid) this.isOtpValid = true;
    },
    closeModal: function () {
      this.doLogout({ noRedirect: true }).then(() => {
        this.$store.dispatch("hideModal", "second-step-verification");
      });
    },
    onModalShown: function () {
      const otp = this.$refs.otpInput;
      this.$nextTick(() => {
        const firstInput = otp.$refs.digitInput[0];
        if (firstInput && typeof firstInput.focus === "function") {
          firstInput.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.second-step-verification {
  .modal-dialog {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    max-width: 400px !important;
    width: 400px !important;
    margin: 0 !important;
  }
  .modal-body {
    padding: 0;
  }
  .modal-header,
  .modal-footer {
    display: none;
  }
  .modal-content {
    border-radius: 36px;
    background: transparent;
    box-shadow: none;
  }
}

.partition-form {
  margin-top: 20px;
}
.boxVerification {
  background: white;
  width: 400px;
  height: 500px;
  justify-self: center;
  overflow: hidden;
  border-radius: 36px;
  box-sizing: border-box;
  box-shadow: 0 0 40px black;
  color: #254b7b;
  font-size: 12px;
  a {
    color: #03a9f4;
    font-size: 15px;
  }
  .form-container {
    text-align: center;
    margin: 0 auto;
  }

  input[type="checkbox"] {
    transform: scale(1.2);
  }
  .partition {
    width: 100%;
    height: 100%;
    .partition-title {
      box-sizing: border-box;
      padding: 30px;
      padding-top: 10px;
      padding-bottom: 0px;
      width: 100%;
      text-align: center;
      letter-spacing: 1px;
      font-size: 30px;
      font-weight: 300;
    }
  }
  .large-btn {
    background: white;
    span {
      font-weight: 600;
    }
    &:hover {
      color: white !important;
    }
  }
}

.pop-out-enter-active,
.pop-out-leave-active {
  transition: all 0.5s;
}
.pop-out-enter,
.pop-out-leave-active {
  opacity: 0;
  transform: translateY(24px);
}

.checkboxLabel {
  font-size: 17px;
  line-height: 17px;
  position: relative;
  bottom: 1px;
}

@media (max-width: 767px) {
  .second-step-verification {
    .modal-dialog {
      width: 90% !important;
      max-width: 90% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      margin: 0 !important;
    }
    .boxVerification {
      width: 100%;
      height: 500px;
    }
  }
}

@media (max-width: 360px) {
  .second-step-verification .modal-dialog {
    max-width: 98% !important;
    width: 98% !important;
  }
}
</style>
